/**
 * global app constants
 *
 */
export const globalConst = {
  routes: {
    HOME: "/home",
    FORCE_NEW_PASSWORD: "/auth/new-password"
  },
  action: {
    // Stuff
    FETCH_STUFFS: "FETCH_STUFFS",
    ADD_NEW_SUFF: "ADD_NEW_SUFF",
    GET_STUFF: "GET_STUFF",
    RESET_STUFF: "RESET_STUFF",
    ACTIVATE_STUFF: "ACTIVATE_STUFF",
    ENABLE_STUFF: "ENABLE_STUFF",
    DISABLE_STUFF: "DISABLE_STUFF",
    FETCH_DEALS: "FETCH_DEALS",
    CREATE_DEAL: "CREATE_DEAL",
    UPDATE_DEAL: "UPDATE_DEAL",
    DELETE_DEAL: "DELETE_DEAL",
    GET_DEAL: "GET_DEAL",
    FETCH_LAWS: "FETCH_LAWS",
    UPDATE_LAWS: "UPDATE_LAWS",

    HIDE_AUCTION: "HIDE_AUCTION",
    UNHIDE_AUCTION: "UNHIDE_AUCTION",

    // prefs
    FETCH_BANNERS: "FETCH_BANNERS",
    CREATE_BANNER: "CREATE_BANNER",
    GET_BANNER: "GET_BANNER",
    UPDATE_BANNER: "UPDATE_BANNER",
    DELETE_BANNER: "DELETE_BANNER",
    FETCH_NEWS: "FETCH_NEWS",
    CREATE_NEWS: "CREATE_NEWS",
    GET_NEWS: "GET_NEWS",
    UPDATE_NEWS: "UPDATE_NEWS",

    // showRooms
    FETCH_SHOWROOMS: "FETCH_SHOWROOMS",
    GET_SHOWROOM: "GET_SHOWROOM",
    UPDATE_SHOWROOM: "UPDATE_SHOWROOM",
    SAVE_SHOWROOM: "SAVE_SHOWROOM",
    ACTIVATE_SHOWROOM: "ACTIVATE_SHOWROOM",
    ENABLE_SHOWROOM: "ENABLE_SHOWROOM",
    DISABLED_SHOWROOM: "DISABLED_SHOWROOM",
    RESET_SHOWROOM: "RESET_SHOWROOM",
    DELETE_SHOWROOM: "DELETE_SHOWROOM",
    FETCH_SHOWROOMS_ITEMS: "FETCH_SHOWROOMS_ITEMS",
    COUNT_NEW_SHOWROOMS_ITEMS: "COUNT_NEW_SHOWROOMS_ITEMS",
    COUNT_PENDING_SHOWROOMS_ITEMS: "COUNT_PENDING_SHOWROOMS_ITEMS",
    PUBLISH_SHOWROOMS_ITEM: "PUBLISH_SHOWROOMS_ITEM",
    UNPUBLISH_SHOWROOMS_ITEM: "UNPUBLISH_SHOWROOMS_ITEM",
    CHANGE_SHOWROOMS_ITEM_STATUS: "CHANGE_SHOWROOMS_ITEM_STATUS",
    UPDATE_SHOWROOMS_ITEM: "UPDATE_SHOWROOMS_ITEM",
    DELETE_SHOWROOMS_ITEM: "DELETE_SHOWROOMS_ITEM",    

    //showrooms items
    FETCH_SHOWROOMS_ITEMS: "FETCH_SHOWROOMS_ITEMS",
    GET_SHOWROOM_ITEM: "GET_SHOWROOM_ITEM",
    UPDATE_SHOWROOM_ITEM: "UPDATE_SHOWROOM_ITEM",
    DELETE_SHOWROOM_ITEM: "DELETE_SHOWROOM_ITEM",
    GET_SHOWROOM_ITEM: "GET_SHOWROOM_ITEM",

    //souq
    FETCH_SOUQ: "FETCH_SOUQ",
    FETCH_MESSAGES: "FETCH_MESSAGES",
    SEND_NOTIFICATION: "SEND_NOTIFICATION",
    FETCH_BANNERS: "FETCH_BANNERS",
    FETCH_SOUQ_ADS: "FETCH_SOUQ_ADS",
    SAVE_SOUQ_ITEM: "SAVE_SOUQ_ITEM",
    SAVE_SOUQ_BANNER: "SAVE_SOUQ_BANNER",
    SAVE_SOUQ_ITEM_IMAGE: "SAVE_SOUQ_ITEM_IMAGE",
    SAVE_SOUQ_ADS: "SAVE_SOUQ_ADS",
    UPDATE_SOUQ_ITEM: "UPDATE_SOUQ_ITEM",
    UPDATE_SOUQ_BANNER: "UPDATE_SOUQ_BANNER",
    GET_SOUQ_ITEM: "GET_SOUQ_ITEM",
    GET_BANNER: "GET_BANNER",
    DELETE_SOUQ_BANNER: "DELETE_SOUQ_BANNER",
    DELETE_SOUQ_ITEM: "DELETE_SOUQ_ITEM",
    ACTIVATE_SOUQ_ITEM: "ACTIVATE_SOUQ_ITEM",
    DELETE_SOUQ_ITEM_IMAGE: "DELETE_SOUQ_ITEM_IMAGE",

    // Customer Souq
    FETCH_CUSTOMER_NEW_SOUQ_ITEMS: "FETCH_CUSTOMER_NEW_SOUQ_ITEMS",
    FETCH_CUSTOMER_PENDING_SOUQ_ITEMS: "FETCH_CUSTOMER_PENDING_SOUQ_ITEMS",
    CHANGE_CUSTOMER_SOUQ_ITEM_STATUS: "CHANGE_CUSTOMER_SOUQ_ITEM_STATUS",
    PUBLISH_CUSTOMER_SOUQ_ITEM: "PUBLISH_CUSTOMER_SOUQ_ITEM",
    COUNT_CUSTOMER_NEW_SOUQ_ITEMS: "COUNT_CUSTOMER_NEW_SOUQ_ITEMS",
    COUNT_CUSTOMER_PENDING_SOUQ_ITEMS: "COUNT_CUSTOMER_PENDING_SOUQ_ITEMS",

    //exhibitions
    FETCH_AGENCES: "FETCH_AGENCES",
    FETCH_AGENCES_ITEMS: "FETCH_AGENCES_ITEMS",
    SAVE_AGENCES: "SAVE_AGENCES",
    UPDATE_AGENCES: "UPDATE_AGENCES",
    SAVE_AGENCES_ITEM: "SAVE_AGENCES_ITEM",
    UPDATE_AGENCES_ITEM: "UPDATE_AGENCES_ITEM",
    GET_AGENCES_ITEM: "GET_AGENCES_ITEM",
    DELETE_PHOTO_AGENCES_ITEM: "DELETE_PHOTO_AGENCES_ITEM",
    ADD_PHOTO_AGENCES_ITEM: "ADD_PHOTO_AGENCES_ITEM",
    UPDATE_AGENCES: "UPDATE_AGENCES",
    DELETE_AGENCES: "DELETE_AGENCES",
    DELETE_AGENCES_ITEM: "DELETE_AGENCES_ITEM",
    GET_SINGLE_AGENCY: "GET_SINGLE_AGENCY",

    //realestate
    RESET_REALESTATE:"RESET_REALESTATE",
    FETCH_REALESTATE_COMPANY: "FETCH_REALESTATE_COMPANY",
    SAVE_REALESTATE_COMPANY: "SAVE_REALESTATE_COMPANY",
    UPDATE_REALESTATE_COMPANY: "UPDATE_REALESTATE_COMPANY",
    DELETE_REALESTATE_COMPANY: "DELETE_REALESTATE_COMPANY",
    DISABLE_REALESTATE_COMPANY: "DISABLE_REALESTATE_COMPANY",
    ENABLE_REALESTATE_COMPANY: "ENABLE_REALESTATE_COMPANY",
    DELETE_REALESTATE_ITEM: "DELETE_REALESTATE_ITEM",
    GET_SINGLE_REALESTATE_COMPANY: "GET_SINGLE_REALESTATE_COMPANY",
    GET_REALESTATE_ITEMS: "GET_REALESTATE_ITEMS",
    GET_REALESTATE_ITEM: "GET_REALESTATE_ITEM",
    ADD_PHOTO_REALESTATE_ITEM: "ADD_PHOTO_REALESTATE_ITEM",
    SAVE_REALESTATE_ITEM: "SAVE_REALESTATE_ITEM",
    DELETE_REALESTATE_ITEM: "DELETE_REALESTATE_ITEM",
    PUBLISH_REALESTATE_ITEM: "PUBLISH_REALESTATE_ITEM",
    UNPUBLISH_REALESTATE_ITEM: "UNPUBLISH_REALESTATE_ITEM",
    FETCH_TEXT_NEWS: "FETCH_TEXT_NEWS",
    UPDATE_TEXT_NEWS: "UPDATE_TEXT_NEWS",
    UPDATE_REALESTATE_ITEM: "UPDATE_REALESTATE_ITEM",
    CHANGE_REALESTATE_ITEM_STATUS:  "CHANGE_REALESTATE_ITEM_STATUS",
    ACTIVATE_REALESTATE: "ACTIVATE_REALESTATE",
    
    FETCH_ALL_RELESTATE_ITEMS: "FETCH_ALL_RELESTATE_ITEMS",
    COUNT_NEW_REALESTATE_ITEMS: "COUNT_NEW_REALESTATE_ITEMS",
    COUNT_PENDING_REALESTATE_ITEMS: "COUNT_PENDING_REALESTATE_ITEMS",
    APPROVE_REALESTATE_ITEM: "APPROVE_REALESTATE_ITEM",
    REJECT_RELESTATE_ITEM: "REJECT_REALESTATE_ITEM",
    // categories
    FETCH_CATEGROEIS: "FETCH_CATEGROEIS",
    ADD_NEW_CATEGORY: "ADD_NEW_CATEGORY",
    GET_CATEGORY: "GET_CATEGORY",

    // customers
    FETCH_CUSTOMERS: "FETCH_CUSTOMERS",
    GET_CUSTOMER: "GET_CUSTOMER",
    SEARCH_CUSTOMER_BY_COUNTRY: "SEARCH_CUSTOMER_BY_COUNTRY",
    VERIFY_CUSTOMER: "VERIFY_CUSTOMER",
    ACTIVATE_CUSTOMER: "ACTIVATE_CUSTOMER",
    BLOCK_CUSTOMER: "BLOCK_CUSTOMER",
    UPDATE_CUSTOMER: "UPDATE_CUSTOMER",
    REJECT_CUSTOMER: "REJECT_CUSTOMER",
    FETCH_RESERVED_NICKNAMES: "FETCH_RESERVED_NICKNAMES",
    SAVE_RESERVED_NICKNAME: "SAVE_RESERVED_NICKNAME",

    // bidding
    FETCH_BIDS: "FETCH_BIDS",
    FETCH_SUMMARY_BIDS: "FETCH_SUMMARY_BIDS",
    FETCH_SALES: "FETCH_SALES",

    // direct sale
    FETCH_DRIECT_SALE: "FETCH_DRIECT_SALE",
    ACTIVATE_ITEM: "ACTIVATE_ITEM",
    DELETE_ITEM: "DELETE_ITEM",
    // refunds
    FETCH_REFUNDS: "FETCH_REFUNDS",
    GET_INSURANCE: "GET_INSURANCE",

    DELETE_ITEM: "DELETE_ITEM",
    CANCEL_ITEM: "CANCEL_ITEM",

    // owners
    FETCH_OWNERS: "FETCH_OWNERS",
    ADD_NEW_OWNER: "ADD_NEW_OWNER",
    GET_OWNER: "GET_OWNER",

    // auctions
    FETCH_AUCTIONS: "FETCH_AUCTIONS",
    UPDATE_AUCTION_COVER: "UPDATE_AUCTION_COVER",
    UPDATE_AUCTION: "UPDATE_AUCTION",
    DELETE_AUCTION: "DELETE_AUCTION",
    UPDATE_AUCTION_EXPIRE: "UPDATE_AUCTION_EXPIRE",
    ACTIVATE_AUCTION: "ACTIVATE_AUCTION",
    CANCEL_AUCTION: "CANCEL_AUCTION",
    DELETE_AUCTION_PHOTO: "DELETE_AUCTION_PHOTO",
    ADD_AUCTION_PHOTO: "ADD_AUCTION_PHOTO",
    CREATE_AUCTION: "CREATE_AUCTION",
    ADD_NEW_AUCTION: "ADD_NEW_AUCTION",
    GET_AUCTION: "GET_AUCTION",
    SET_WINNER: "SET_WINNER",

    // analytics
    FETCH_ANALYTICS: "FETCH_ANALYTICS",
    FETCH_TOTAL_ANALYTICS: "FETCH_TOTAL_ANALYTICS",
    FETCH_BIDAGREGATE: "FETCH_BIDAGREGATE",

    // Companies
    FETCH_COMAPNIES: "FETCH_COMAPNIES",
    ADD_NEW_COMAPNIES: "ADD_NEW_COMAPNIES",
    GET_COMAPNIES: "GET_COMAPNIES",
    ACTIVATE_COMAPNIES: "ACTIVATE_COMAPNIES",
    ENABLE_COMAPNIES: "ENABLE_COMAPNIES",
    DISABLE_COMAPNIES: "DISABLE_COMAPNIES",

    FETCH_SINGLE_STUFF: "FETCH_SINGLE_STUFF",
    DISABLE_STUFF: "DISABLE_STUFF",
    ENABLE_STUFF: "ENABLE_STUFF",
    VIEW_GALLERY_ITEM: "VIEW_GALLERY_ITEM",
    RESET_PASSWORD_STUFF: "RESET_PASSWORD_STUFF",
    UPDATE_STUFF: "UPDATE_STUFF",
    DELETE_STUFF: "DELETE_STUFF",
    NONE: "NONE",
    SIGNIN: "SIGNIN",
    FORCE_NEW_PASSWORD: "FORCE_NEW_PASSWORD",
    NEW_PASSWORD_COMPLETE: "NEW_PASSWORD_COMPLETE",
    UPDATE_PROFILE: "UPDATE_PROFILE",
    SIGNOUT: "SIGNOUT",

    // Features
    ADD_NEW_FEATURE: "ADD_NEW_FEATURE",
    UPDATE_FEATURE: "UPDATE_FEATURE",
    DELETE_FEATURE: "DELETE_FEATURE",
    ACTIVATE_FEATURE: "ACTIVATE_FEATURE",
    DISABLE_FEATURE: "DISABLE_FEATURE",
    FETCH_ALL_FEATURE: "FETCH_ALL_FEATURE",
    FETCH_SINGLE_FEATURE: "FETCH_SINGLE_FEATURE",

    // companies
    ADD_NEW_COMPANY: "ADD_NEW_COMPANY",
    UPDATE_COMPANY: "UPDATE_COMPANY",
    DELETE_COMPANY: "DELETE_COMPANY",
    ACTIVATE_COMPANY: "ACTIVATE_COMPANY",
    DISABLE_COMPANY: "DISABLE_COMPANY",
    FETCH_ALL_COMPANY: "FETCH_ALL_COMPANY",
    FETCH_SINGLE_COMPANY: "FETCH_SINGLE_COMPANY",

    // tags
    ADD_NEW_TAG: "ADD_NEW_TAG",
    UPDATE_TAG: "UPDATE_TAG",
    DELETE_TAG: "DELETE_TAG",
    ACTIVATE_TAG: "ACTIVATE_TAG",
    DISABLE_TAG: "DISABLE_TAG",
    FETCH_ALL_TAG: "FETCH_ALL_TAG",
    FETCH_SINGLE_TAG: "FETCH_SINGLE_TAG",

    // property type
    ADD_NEW_PROPERTY_TYPE: "ADD_NEW_PROPERTY_TYPE",
    UPDATE_PROPERTY_TYPE: "UPDATE_PROPERTY_TYPE",
    DELETE_PROPERTY_TYPE: "DELETE_PROPERTY_TYPE",
    ACTIVATE_PROPERTY_TYPE: "ACTIVATE_PROPERTY_TYPE",
    DISABLE_PROPERTY_TYPE: "DISABLE_PROPERTY_TYPE",
    FETCH_ALL_PROPERTY_TYPE: "FETCH_ALL_PROPERTY_TYPE",
    FETCH_SINGLE_PROPERTY_TYPE: "FETCH_SINGLE_PROPERTY_TYPE",

    // realState
    ADD_NEW_REALSTATE: "ADD_NEW_REALSTATE",
    CHECK_REALSTATE_REFERENCE: "CHECK_REALSTATE_REFERENCE",
    SAVE_REAL_STATE_ASSET: "SAVE_REAL_STATE_ASSET",
    DELETE_REALSTATE_ASSET: "DELETE_REALSTATE_ASSET",
    UPDATE_REALSTATE: "UPDATE_REALSTATE",
    PUBLISH_REALSTATE: "PUBLISH_REALSTATE",
    RENEW_REALSTATE: "RENEW_REALSTATE",
    CONFIRM_REALSTATE: "CONFIRM_REALSTATE",
    REJECT_REALSTATE: "REJECT_REALSTATE",
    APPROVE_REALSTATE: "APPROVE_REALSTATE",
    DELETE_REALSTATE: "DELETE_REALSTATE",
    ACTIVATE_REALSTATE: "ACTIVATE_REALSTATE",
    DISABLE_REALSTATE: "DISABLE_REALSTATE",
    FETCH_ALL_REALSTATE: "FETCH_ALL_REALSTATE",
    FETCH_SINGLE_REALSTATE: "FETCH_SINGLE_REALSTATE",
    UPDATE_REALSTATE_STATUS: "UPDATE_REALSTATE_STATUS",
    UPDATE_REALSTATE_STATUS_TAKEN: "UPDATE_REALSTATE_STATUS_TAKEN",
    UPDATE_REALSTATE_STATUS_REVIEW: "UPDATE_REALSTATE_STATUS_REVIEW",
    UPDATE_REALSTATE_STATUS_REJECT: "UPDATE_REALSTATE_STATUS_REJECT",
    UPDATE_REALSTATE_STATUS_CONFIRM: "UPDATE_REALSTATE_STATUS_CONFIRM",
    UPDATE_REALSTATE_STATUS_CHECK: "UPDATE_REALSTATE_STATUS_CHECK",
    UPDATE_REALSTATE_STATUS_PUBLSIHED: "UPDATE_REALSTATE_STATUS_PUBLSIHED",
    UPDATE_REALSTATE_STATUS_PENDING: "UPDATE_REALSTATE_STATUS_PENDING",
    UPDATE_REALSTATE_STATUS_UNPUBLSIHED: "UPDATE_REALSTATE_STATUS_UNPUBLSIHED",

    // notifications
    FETCH_NOTIFICATIONS: "FETCH_NOTIFICATIONS",
    SEND_NOTIFICATIONS: "SEND_NOTIFICATIONS",
    // contract
    ADD_NEW_CONTRACT: "ADD_NEW_CONTRACT",
    UPDATE_CONTRACT: "UPDATE_CONTRACT",
    DELETE_CONTRACT: "DELETE_CONTRACT",
    ACTIVATE_CONTRACT: "ACTIVATE_CONTRACT",
    DISABLE_CONTRACT: "DISABLE_CONTRACT",
    FETCH_ALL_CONTRACT: "FETCH_ALL_CONTRACT",
    FETCH_SINGLE_CONTRACT: "FETCH_SINGLE_CONTRACT",

    // construction type
    ADD_NEW_CONSTRUCTION_TYPE: "ADD_NEW_CONSTRUCTION_TYPE",
    UPDATE_CONSTRUCTION_TYPE: "UPDATE_CONSTRUCTION_TYPE",
    DELETE_CONSTRUCTION_TYPE: "DELETE_CONSTRUCTION_TYPE",
    ACTIVATE_CONSTRUCTION_TYPE: "ACTIVATE_CONSTRUCTION_TYPE",
    DISABLE_CONSTRUCTION_TYPE: "DISABLE_CONSTRUCTION_TYPE",
    FETCH_ALL_CONSTRUCTION_TYPE: "FETCH_ALL_CONSTRUCTION_TYPE",
    FETCH_SINGLE_CONSTRUCTION_TYPE: "FETCH_SINGLE_CONSTRUCTION_TYPE",
    // cities
    ADD_NEW_CITY: "ADD_NEW_CITY",
    UPDATE_CITY: "UPDATE_CITY",
    DELETE_CITY: "DELETE_CITY",
    ACTIVATE_CITY: "ACTIVATE_CITY",
    DISABLE_CITY: "DISABLE_CITY",
    FETCH_ALL_CITY: "FETCH_ALL_CITY",
    FETCH_SINGLE_CITY: "FETCH_SINGLE_CITY",
    // leads
    FETCH_SINGLE_LEAD: "FETCH_SINGLE_LEAD",
    FETCH_ALL_LEADS: "FETCH_ALL_LEADS",
    // notifications
    ADD_NEW_NOTIFICATION: "ADD_NEW_NOTIFICATION",
    UPDATE_NOTIFICATION: "UPDATE_NOTIFICATION",
    DELETE_NOTIFICATION: "DELETE_NOTIFICATION",
    ACTIVATE_NOTIFICATION: "ACTIVATE_NOTIFICATION",
    DISABLE_NOTIFICATION: "DISABLE_NOTIFICATION",
    FETCH_ALL_NOTIFICATION: "FETCH_ALL_NOTIFICATION",
    FETCH_SINGLE_NOTIFICATION: "FETCH_SINGLE_NOTIFICATION",
    // regions
    ADD_NEW_REGION: "ADD_NEW_REGION",
    UPDATE_REGION: "UPDATE_REGION",
    DELETE_REGION: "DELETE_REGION",
    ACTIVATE_REGION: "ACTIVATE_REGION",
    DISABLE_REGION: "DISABLE_REGION",
    FETCH_ALL_REGION: "FETCH_ALL_REGION",
    FETCH_SINGLE_REGION: "FETCH_SINGLE_REGION"
  },

  auth: {
    groups: {
      NO_GROUP: "no_group",
      SUPERADMINS: "superAdmins",
      ADMINS: "Admins",
      CHECKER: "Checker",
      CHECKERAR: "CheckerAr",
      SUPERVISOR: "Supervisor",
      DATAENTRY: "dataEntry",
      MARKETER: "Marketer",
      SALES: "Sales"
    }
  }
}

export const typeCars = {
  color: "",
  condition: "",
  cylinder: "",
  gear: "",
  guarantee: "",
  inspection: "",
  kilometers: "",
  location: {},
  make: "",
  subType: "",
  model: "",
  owner: "",
  year: ""
}

export const typeProperty = {
  city: "",
  category: "",
  region: "",
  furniture: "",
  level: "",
  bathroom: "",
  location: {},
  type: "",
  owner: ""
}
export const typePhone = {
  city: "",
  type: "",
  owner: ""
}
export const typePlate = {
  city: "",
  type: "",
  category: "",
  privilege: "",
  from: "",
  to: "",
  owner: ""
}

export const typeMarineEquipment = {
  // model: "",
  year: "",
  color: "",
  furniture: "",
  location: {},
  note: "",
  owner: ""
}

export const typeHeavyEquipment = {
  color: "",
  condition: "",
  // cylinder: "",
  // gear: "",
  guarantee: "",
  inspection: "",
  kilometers: "",
  location: {},
  make: "",
  // model: "",
  owner: "",
  year: ""
}
export const typeLuxury = {
  owner: ""
}

export const typeGeneral = {
  owner: ""
}
